import { calc } from '@/components/Quiz/questions'
const sides = ['right', 'left', 'right', 'left', 'right']
import { getBreakpointView } from "@/ulils/responsive.breakpoints"


export const steps = {
  INTRO: 'intro',
  QUESTION: 'question',
  FINAL: 'final'
}

export default {
  state: {
    busy: false,
    questions: null,
    current: null,
    score: [],
    results: null,
    sides,
    animation: { duration: 3000, carDelay: 250 },
    durations: null,
    carSpeed: 0.7,
    responsive: null,

    showCityBack: false
  },

  getters: {
    isQuizMiddle (state) {
      if (!state.questions) return
      return (state.current + 1) === state.questions.length/2
    },
    view (state) {
      if (!state.responsive) return
      return getBreakpointView(state.responsive.breakpoint)
    },
    duration (state) {
      if (!state.durations) return null
      return state.durations.reduce((acc, value) => (acc + value), 0)
    },
    bullets (state) {
      const score = state.score
      const count = state.questions.length
      const items = []

      for (let idx = 0; idx < count; idx++) {
        items.push({ correct: score[idx] ? score[idx].correct: null })
      }

      return items
    },
    step (state) {
      if (state.results) return steps.FINAL
      if (state.current === null) return steps.INTRO
      return steps.QUESTION
    },
    answered (state) {
      return !!state.score[state.current]
    },
    correct (state, getters) {
      return getters.answered ? state.score[state.current].correct : null
    },
    question (state) {
      if (state.current === null) return null
      return state.questions[state.current]
    },
    isLastStep (state) {
      if (!state.questions) return false
      return state.current >= (state.questions.length - 1)
    }
  },

  actions: {
    init ({ state, commit }, questions) {
      if (state.busy) return
      commit('init', questions.slice())
      commit('reset')
    },

    answer ({ getters, commit }, idx) {
      if (typeof idx !== 'number') throw Error('Answer should be a number')
      const q = getters.question
      commit('answer', {
        value: idx,
        correct: q.correct === idx,
        score: q.options[idx].value
      })
    },

    next ({ state, commit, getters }) {
      if (state.busy) return
      if (getters.isLastStep) commit('calc')
      commit('next')
    },

    reset ({ commit }) {
      commit('reset')
    }

  },

  mutations: {
    busy (state, value) {
      state.busy = value
    },

    init (state, questions) {
      state.questions = questions
    },

    reset (state) {
      state.questions.forEach((question) => (question.option = null))
      state.current = 0
      state.score = []
      state.results = null
    },

    answer (state, answer) {
      state.score = state.score.concat(answer)
    },

    next (state) {
      state.current = state.current + 1
    },

    calc (state) {
      const count = state.score.filter((item) => !!item.correct).length
      state.results = calc(count)
    },

    durations (state, durations) {
      state.durations = durations
    },

    _set (state, [field, value]) {
      state[field] = value
    },

    resized (state, value) {
      state.responsive = value
    }
  }
}
